/**CORE LIBRARIES IMPORT */
import React from "react";

/**HOOKS IMPORT */
import useSiteSettings from "../hooks/useSiteSettings";

/**
 * Image for a fixed website slot managed in the portal (Website Media).
 * Crops responsively to `ratio` around the chosen focal point. Without an
 * uploaded image it renders `fallback` (e.g. the venue photo or the branded
 * PhotoPlaceholder), so nothing unfinished is ever shown publicly.
 */
const SiteImage = ({ slot, ratio = "4 / 3", fallback = null, className = "", eager = false }) => {
  const { media } = useSiteSettings();
  const image = media?.[slot];
  if (!image) return fallback;
  return (
    <div className={`site-image ${className}`} style={{ aspectRatio: ratio }}>
      <img
        src={image.src}
        alt={image.alt}
        style={{ objectPosition: image.position }}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
      />
    </div>
  );
};

export default SiteImage;
